import { invitationQueryKeys as e } from "./useInvitationQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { bookingsApi as n } from "@maat/api-booking";
//#region src/invitations/useBookingInvitationsQuery.ts
var r = 50, i = (i, a) => t({
	queryKey: e.list(i),
	fetchPage: (e) => n.listBookingInvitations({
		limit: r,
		offset: (e - 1) * r,
		status: i?.status
	}),
	key: "invitations",
	enabled: a?.enabled ?? !0
});
//#endregion
export { i as useBookingInvitationsQuery };
